import { render, staticRenderFns } from "./service-providers.vue?vue&type=template&id=3b37ff00&scoped=true"
import script from "./service-providers.vue?vue&type=script&lang=ts"
export * from "./service-providers.vue?vue&type=script&lang=ts"
import style0 from "./service-providers.vue?vue&type=style&index=0&id=3b37ff00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b37ff00",
  null
  
)

export default component.exports